import * as CSS from "csstype";
import styled from "styled-components";

import { RESPONSIVE } from "helpers/responsive";

export const FlexWrapper = styled.div<CSS.Properties>`
  display: flex;
  flex-wrap: wrap;
  align-items: ${(p) => p.alignItems || "center"};
  justify-content: ${(p) => p.justifyContent || "space-between"};
  > *:not(:last-child) {
    margin: 0px;
    margin-right: ${
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (p: any) => p.contentsMargin || "10px"
    };
  }
`;

export const RouteActionWrapper = styled(FlexWrapper)`
  margin-bottom: 2rem;
  width: 100%;

  @media ${RESPONSIVE.DESKTOP} {
    width: 50%;
  }
`;

export const PreparedRoutesByWorkplacesWrapper = styled.div`
  margin-bottom: 6rem;

  &:not(:nth-child(2)) {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
`;
